import React from 'react'
import styled from 'styled-components'
import fontawesome from '@fortawesome/fontawesome'
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/fontawesome-free-brands'

import Text from '../components/Text'
import FadeIn from '../components/FadeIn'
import PageTitle from '../components/PageTitle'
import PageHeading from '../components/PageHeading'

import config from '../config'

import aleImg from '../assets/alex-prioni.png'
import dianneImg from '../assets/dianne-eberhardt.png'

const PersonImg = styled.img`
  width: 50%;
  margin: 0;
`

const PersonContainer = styled.div`
  margin-top: 2rem;
  line-height: 1;
`

const PersonInfo = styled.div`
  margin-top: ${config.padding};
`

const PersonName = styled.h2`
  display: inline;
`

const PersonTitle = PersonName.extend`
  font-weight: 300;
  font-family: ${config.serifFonts.toString()}
`

const IconsContainer = styled.div`
  margin-top: ${config.padding};
`

const IconLink = styled.a`
  color: black;
  line-height: 1;
`

class Person extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <PersonContainer>
        <PersonImg src={this.props.img} />
        <PersonInfo>
          <PersonName>{this.props.name} </PersonName>
          <PersonTitle>{this.props.title}</PersonTitle>
          <IconsContainer>
            <IconLink href={this.props.link} target="_blank">
              <FontAwesomeIcon icon={faLinkedin} />
            </IconLink>
          </IconsContainer>
        </PersonInfo>
      </PersonContainer>
    );
  }
}

const WhoWeArePage = () => (
  <FadeIn>
    <PageTitle title='Who We Are' />
    <PageHeading>who we are</PageHeading>
    <Person name="Alex Prioni" title="Ceo and head of strategy" link='https://www.linkedin.com/in/aprioni/' img={aleImg} />
    <Person name="Dianne Eberhardt" title="Head of design" link='https://www.linkedin.com/in/dianneeberhardt/' img={dianneImg} />
  </FadeIn>
)

export default WhoWeArePage



// WEBPACK FOOTER //
// ./src/pages/who-we-are.js